import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect, useState } from 'react'
import { reportService } from '../services/reportService'
import { ReportWithdrawsParams } from '../services/reportService/reportWithdraws'
import { startOfMonth, endOfMonth } from 'date-fns'

export const useReportWithdraws = () => {
  const [params, setParams] = useState<ReportWithdrawsParams | undefined>({
    startDate: startOfMonth(new Date()).toISOString(),
    endDate: endOfMonth(new Date()).toISOString(),
  })
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['reportWithdraws', params],
    queryFn: async () => reportService.reportWithdraws(params),
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
  }
}
